<h3>{{ isEditingBranch ? 'Edycja Oddziału' : 'Edycja Danych Partnera' }}</h3>

<!-- Partner Inactive Warning -->
@if (currentPartner && !currentPartner.is_active) {
  <div class="partner-status-warning">
    <mat-icon color="warn">warning</mat-icon>
    <div class="warning-content">
      <strong>Partner nieaktywny</strong>
      <p>Ten partner jest obecnie nieaktywny. Może to oznaczać ograniczenia w funkcjonalności.</p>
    </div>
  </div>
}


<!-- Partner Logo Display -->
@if (isEditingBranch) {
  <div class="branch-header">
    <button mat-raised-button color="accent" (click)="goBackToMainPartner()">
      <mat-icon>arrow_back</mat-icon>
      Powrót do głównego partnera
    </button>
    <p class="branch-info">Edytujesz oddział: <strong>{{ currentPartner?.name }}</strong></p>
  </div>
}

<!-- Loading Spinner for initial load -->
@if (loading && !partnerId) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Ładowanie danych partnera...</p>
  </div>
}

<!-- No Partner Message -->
@if (!loading && !partnerId) {
  <div class="no-partner-message">
    <mat-icon>info</mat-icon>
    <p>Brak przypisanego partnera do Twojego konta.</p>
  </div>
}

<!-- Main Content - Always visible when partner exists -->
@if (partnerId) {
  <div class="partner-edit-container">
    <!-- Loading overlay for save operation -->
    @if (saving) {
      <div class="saving-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Zapisywanie...</span>
      </div>
    }
    <form [formGroup]="partnerForm" (ngSubmit)="onSubmit()">'
      <div class="form-columns">
        <div class="form-column">
          <!-- Basic Information Section -->
          <div class="form-section">
            <h4>Podstawowe informacje</h4>
            @if (localLogoPreview || partnerForm.get('file')?.value) {
              <div class="current-logo">
                <img [src]="localLogoPreview || getPartnerLogoUrl($safeNavigationMigration(partnerForm.get('file')?.value))"
                  alt="Aktualne logo partnera" class="partner-logo-preview">
              </div>
            }
            <div class="input-holder">
              <label>URL</label>
              <input matInput formControlName="url" placeholder="https://example.com">
            </div>
            <div class="input-holder">
              <label>Kontakt</label>
              <input matInput formControlName="contact" placeholder="Email, telefon, itp.">
            </div>
          </div>
        </div>
        <div class="form-column">
          <!-- Logo Upload Section -->
          @if (false) {
            <div class="form-section">
              <h4>Logo partnera</h4>
              <p class="section-hint">Przesłane logo zostanie zapisane po kliknięciu "Zapisz zmiany"</p>
              <!-- Current Logo Display -->
              @if (localLogoPreview || partnerForm.get('file')?.value) {
                <div class="current-logo">
                  <img [src]="localLogoPreview || getPartnerLogoUrl($safeNavigationMigration(partnerForm.get('file')?.value))"
                    alt="Aktualne logo partnera" class="partner-logo-preview">
                  @if (localLogoPreview) {
                    <p>Podgląd: {{ selectedLogoFile?.name }}</p>
                  }
                  @if (!localLogoPreview && partnerForm.get('file')?.value) {
                    <p>Wybrane logo: {{
                    partnerForm.get('file')?.value }}</p>
                  }
                </div>
              }
              <!-- File Input -->
            </div>
          }
          <!-- Location Section -->
          <div class="form-section">
            <h4>Lokalizacja</h4>
            <div class="input-holder">
              <label>Wyszukaj adres</label>
              <input matInput [value]="addressQuery" (input)="onAddressInput($event)"
                placeholder="Wpisz adres i naciśnij Enter"
                (keydown.enter)="$event.preventDefault(); searchAddress();">
            </div>
            <div class="map-container">
              <label>Wybierz lokalizację na mapie (kliknij aby ustawić marker)</label>
              <app-map-view
                [interactive]="true"
                [centerMap]="mapCenter"
                [zoomMap]="mapZoom"
                [pointerLocal]="mapPointer"
                (locationPicked)="onMapLocationPicked($event)">
              </app-map-view>
            </div>
            <div class="coordinates-row">
              <div class="input-holder">
                <label>Szerokość geograficzna</label>
                <input matInput formControlName="latitude" placeholder="Latitude" readonly>
              </div>
              <div class="input-holder">
                <label>Długość geograficzna</label>
                <input matInput formControlName="longitude" placeholder="Longitude" readonly>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Error Message -->
      @if (error) {
        <div class="error-message">{{ error }}</div>
      }
      <!-- Actions -->
      <div class="actions-container">
        <button mat-raised-button color="primary" type="submit" [disabled]="partnerForm.invalid || saving">
          <mat-icon>save</mat-icon>
          Zapisz zmiany
        </button>
      </div>
    </form>
    @if (false) {
      <div>
        <h3>Oferty Partnera</h3>
        <!-- Show offer edit form when editing -->
        @if (showOfferEdit) {
          <div>
            <app-parnter-offer-edit [offerId]="editingOfferId" [partnerId]="partnerId" (offerSaved)="closeOfferEdit()">
            </app-parnter-offer-edit>
            <div class="offer-edit-actions">
              <button mat-button color="warn" (click)="closeOfferEdit()">
                <mat-icon>cancel</mat-icon>
                Anuluj
              </button>
            </div>
          </div>
        }
        <!-- Offers table when not editing -->
        @if (!showOfferEdit) {
          <div>
            <!-- Add new offer button -->
            <div class="offers-header">
              <button mat-raised-button color="primary" (click)="createNewOffer()">
                <mat-icon>add</mat-icon>
                Dodaj nową ofertę
              </button>
            </div>
            <!-- Offers Loading -->
            @if (offersLoading) {
              <div class="loading-container">
                <mat-spinner></mat-spinner>
                <p>Ładowanie ofert...</p>
              </div>
            }
            <!-- No offers message -->
            @if (!offersLoading && offers.length === 0) {
              <div class="no-offers-message">
                <mat-icon>info</mat-icon>
                <p>Brak ofert dla tego partnera.</p>
              </div>
            }
            <!-- Offers table -->
            @if (!offersLoading && offers.length > 0) {
              <div class="offers-list">
                <table class="offers-table">
                  <thead>
                    <tr>
                      <th>Tytuł</th>
                      <th>Zniżka</th>
                      <th>Ważne do</th>
                      <th>Status</th>
                      <th>Akcje</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (offer of offers; track offer) {
                      <tr>
                        <td>{{ offer.title }}</td>
                        <td>{{ offer.discount || '-' }}</td>
                        <td>{{ formatValidDate(offer.valid) }}</td>
                        <td>
                          <span class="status-badge" [class.active]="offer.is_active"
                            [class.inactive]="!offer.is_active">
                            {{ offer.is_active ? 'Aktywna' : 'Nieaktywna' }}
                          </span>
                        </td>
                        <td>
                          <button mat-icon-button color="primary" (click)="editOffer(offer)"
                            title="Edytuj ofertę">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-icon-button color="warn" (click)="deleteOffer(offer)" title="Usuń ofertę">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

<!-- Branches List - Only show when editing main partner -->
@if (!isEditingBranch && false) {
  <div>
    <h3>Lista oddziałów</h3>
    <!-- Branches List -->
    @if (branchesLoading) {
      <div class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Ładowanie oddziałów...</p>
      </div>
    }
    @if (!branchesLoading && branches.length === 0) {
      <div class="no-branches-message">
        <mat-icon>info</mat-icon>
        <p>Brak oddziałów dla tego partnera.</p>
      </div>
    }
    @if (!branchesLoading && branches.length > 0) {
      <div class="branches-list">
        <table class="branches-table">
          <thead>
            <tr>
              <th>Nazwa</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            @for (branch of branches; track branch) {
              <tr>
                <td>{{ branch.name }}</td>
                <td>
                  <button mat-icon-button color="primary" (click)="editBranch(branch)" title="Edytuj oddział">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}